import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterField } from '../../models/filter-option.model';
import { FILTROS_DEFAULT } from '../../data/filters.data';

/**
 * Panel superior de filtros. Replica los fieldsets con leyenda teal,
 * los chips de Select2 y los botones Aplicar / Limpiar.
 */
@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrl: './filter-panel.component.scss',
  standalone: false,
})
export class FilterPanelComponent {

  @Input() fields: Array<FilterField> = [];
  @Output() applied = new EventEmitter<Record<string, Array<string>>>();

  public value: Record<string, Array<string>> = { ...FILTROS_DEFAULT };

  public onChange(key: string, values: Array<string>): void {
    this.value = { ...this.value, [key]: values };
  }

  public apply(): void {
    this.applied.emit(this.value);
  }

  public clear(): void {
    this.value = {};
  }
}
